import React from 'react';
import { useParams } from 'react-router-dom';

const EducatorCourse = () => {
  const { id } = useParams();

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Course Management</h1>
      <p className="text-gray-600">Course ID: {id}</p>
      <p className="mt-4">Course management interface coming soon...</p>
    </div>
  );
};

export default EducatorCourse;